<template>
  <div
    class="gzir flex-column"
    :class="{
      active: isActive,
    }"
    ref="container"
    v-if="!hide"
    :id="'freebook_' + bookIndex + '_' + gzirIndex"
  >
    <div class="flex flex-bet">
      <span v-show="page > 0" class="text-page">{{
        $t("general.page") + " " + page
      }}</span>
    </div>

    <div class="relative" :class="{ 'full-image': fullImage }">
      <spinnerCircle v-show="showSpinner" :margin="30" />
      <!--   <span
        class="icon-full-screen-gzir icon-otzar otz-icon-square otz-icon"
        @click="toggleFullImage"
      >
        <span v-if="fullImage">e</span>
        <span v-if="!fullImage">e</span>
      </span> -->
      <canvas class="gzirImg" ref="image" @click="openResultInBook" />
      <!-- @dblclick="toggleFullImage" temp remove enlarge image -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getImageObject } from "@/services/bookData.js";
import { getCoordsForGzirim } from "@/services/freeSearch.js";
export default {
  props: ["book", "gzirHeight", "words", "gzirIndex", "bookIndex"],

  data() {
    return {
      fullImage: false,
      img: "",
      page: 0,
      pageId: "",
      coords: [],
      showSpinner: false,
      hide: false,
      gzirTop: 0,
      canvasWidth: 0,
      // gzirHeight:
    };
  },
  computed: {
    ...mapState("tabsManager", ["resizeToggle"]),
    isActive() {
      let indexInStr =
        this.bookIndex.toString() + "." + (this.gzirIndex + 1).toString();
      return this.$store.state.currentActiveListIndex.toString() === indexInStr;
    },
    /*  gzirHeight(
      return this.userSettings.settings.gzirHeight
    } */
  },
  watch: {
    resizeToggle: function (val, oldVal) {
      this.setCanvasSize();
      this.draw();
    },
    gzirHeight: function (val, oldVal) {
      this.doGzir();
    },
  },
  methods: {
    openResultInBook() {
      let indexInStr =
        this.bookIndex.toString() + "." + (this.gzirIndex + 1).toString();
      this.$store.state.currentActiveListIndex = indexInStr;
      this.$emit("openbook", this.page);
    },
    toggleFullImage() {
      this.fullImage = !this.fullImage;
      let canvas = this.$refs.image;
      if (this.fullImage) {
        let originWidth = this.img.width;
        let originHeight = this.img.height;
        let img = this.img.picture;
        let originImgRatio = originWidth / originHeight;
        let canvasWRatio = canvas.width / originWidth;
        let canvasFullHeight = originHeight * canvasWRatio;
        canvas.height = canvasFullHeight;
      } else canvas.height = this.gzirHeight;
      this.draw();
    },
    getCropRect(canvasWidth) {
      try {
        const topMargin = 100;
        let max = [{ top: 100 }];

        try {
          //get highest word
          max = this.coords.reduce(function (prev, current) {
            return prev.top > current.top ? prev : current;
          });
        } catch (ex) {}
        this.gzirTop = max[0].top - topMargin < 0 ? 0 : max[0].top - topMargin;
        return {
          x: 0,
          y: this.gzirTop,
          w: 0,
          h:
            this.gzirHeight === 100 ? 0.2 : this.gzirHeight === 100 ? 0.3 : 0.4, //  Number((this.gzirHeight / canvasWidth).toFixed(2)),
        };
      } catch (ex) {
        return {
          x: 0,
          y: 0,
          w: 0,
          h: 0,
        };
      }
    },
    draw() {
      if (this.img == "") return;
      let topCoord;

      let max = [{ top: 100 }];
      try {
        //get highest word
        max = this.coords.reduce(function (prev, current) {
          return prev.top > current.top ? prev : current;
        });
      } catch (ex) {}
      let canvas = this.$refs.image;
      if (canvas == undefined) return;
      let canvasCtx = canvas.getContext("2d");

      let img = this.img.picture;
      let imageMetaData = this.img.imageMetaData;
      let originWidth =
        imageMetaData.width && imageMetaData.width != 0
          ? imageMetaData.width
          : this.img.width;
      let originHeight =
        imageMetaData.height && imageMetaData.height != 0
          ? imageMetaData.height
          : this.img.height;

      let marginTop = imageMetaData.top;
      let originImgRatio = originWidth / originHeight;

      let canvasWRatio = canvas.width / originWidth;
      let canvasFullHeight = originHeight * canvasWRatio;
      let canvasHRatio = canvasFullHeight / originHeight;

      let w;
      let h = 0;
      let top = 0,
        ctop = 0;

      let height = (canvas.height / canvasFullHeight) * originHeight;
      if (globalThis.SERVER_MODE == "online" && this.img?.imageMetaData?.crop) {
        let rect = this.getCropRect(this.canvasWidth);
        h = (img.height / originHeight) * rect.y;
        marginTop = rect.y; // h * (img.height / originHeight);
        height *= img.height / originHeight;
      }
      /*  if (!this.fullImage) {
        top = max[0].top;
        ctop = max[0].top - 100;
        height = canvas.height / canvasHRatio;

        if (this.img.webP) {
          top *= originHeight / ((originHeight * 3000) / originWidth);
        }
        top -= 100;
      } */

      //height = canvas.height / canvasHRatio;
      canvasCtx.clearRect(0, 0, canvas.width, canvas.height);

      canvasCtx.drawImage(
        img,
        0,
        h,
        img.width,
        height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      let webP = imageMetaData.PDF || this.img.webP;
      if (webP) {
        originHeight *= 3000 / originWidth;
        originWidth = 3000;

        canvasWRatio = canvas.width / originWidth;
        canvasFullHeight = originHeight * canvasWRatio;
        canvasHRatio = canvasFullHeight / originHeight;
      }
      canvasCtx.globalCompositeOperation = "multiply";

      this.coords.forEach((fs) => {
        fs.forEach((c) => {
          canvasCtx.fillStyle = "rgba(255,255,0)";
          canvasCtx.fillRect(
            c.left * canvasWRatio,
            (c.top - marginTop) * canvasHRatio,
            c.width * canvasWRatio,
            c.height * canvasHRatio
          );
        });
      });
    },
    setCanvasSize() {
      if (this.$refs.container == undefined) return;
      let canvas = this.$refs.image;
      let container = this.$refs.container;
      canvas.width = container.clientWidth;
      canvas.height = this.gzirHeight;
      this.canvasWidth = canvas.width;
      return canvas.width;
    },
    async getImg(cropRect) {
      try {
        let img;

        try {
          img = await getImageObject(
            this.book,
            this.pageId,
            "url",
            false,
            {
              ...cropRect,
              resize: this.canvasWidth,
            },
            null,
            this.page
          );
        } catch (ex) {
          console.error("gzir error>>", ex);
          this.showSpinner = false;
        }

        this.img = img;
        this.showSpinner = false;
      } catch (ex) {
        this.showSpinner = false;
      }
    },
    async doGzir() {
      try {
        this.showSpinner = true;
        let canvasWidth = this.setCanvasSize();

        let coordsData = await getCoordsForGzirim(this.words, this.book);

        this.coords = coordsData.coords;
        if (this.coords === undefined) {
          this.hide = true;
          return;
        }
        this.page = coordsData.page;
        this.pageId = coordsData.pageId;

        setTimeout(async () => {
          try {
            await this.getImg(this.getCropRect(canvasWidth));
            this.draw();
          } catch (ex) {
            this.showSpinner = false;
          }
        }, 0);
      } catch (ex) {
        console.error(ex);
        this.showSpinner = false;
      }
    },
  },
  mounted() {
    this.$refs.container.style.height = (this.gzirHeight || 100) + 30 + "px";
    this.doGzir();
  },
  created() {},
};
</script>
<style lang="scss" scoped>
$bg-color3: #e5e5e5;
.gzir {
  position: relative;
  width: 100%;
  padding: 0 11px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 6px;
  &:hover {
    canvas {
      box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
        0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
    }
  }
  &.active {
    background-color: var(--text-color8);
  }
  .text-page {
    direction: ltr;
    text-align: left;
    font-size: 12px;
    line-height: 17px;
    padding-left: 3px;
    font-weight: 500;
    color: var(--text-color1);
  }
}
.gzirImg {
  width: 100%;
  border: 2px solid #d2d2d2;
  background-color: #fff;
  max-width: 100%;
}
.full-image {
  height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.icon-full-screen-gzir {
  position: absolute;
  left: 2px;
  top: 2px;
  background-color: #00000040 !important;
  color: #000 !important;
  border-radius: 0 !important;
  // font-weight: 600;
  * {
    color: #000 !important;
  }
}
</style>
